$('#opened').bind('click', function () {
  const $this = $(this)
  $('#drawer').show(function () {
    $this.toggleClass('active')
    $(this).toggleClass('active')
  })
})
